import React, { useEffect, useState } from 'react';
import { useNetwork } from '../../hooks/useNetwork';
import './NetworkSelector.css';

function NetworkSelector() {
  const { currentNetwork, switchNetwork } = useNetwork();
  const [networks, setNetworks] = useState([]);

  useEffect(() => {
    const fetchNetworks = async () => {
      if (window.ethereum && window.ethereum.request) {
        try {
          const chainId = await window.ethereum.request({ method: 'eth_chainId' });
          const networkName = getNetworkName(chainId);
          setNetworks([{ chainId, chainName: networkName }]);
        } catch (error) {
          console.error("Error fetching network information:", error);
        }
      }
    };

    fetchNetworks();
  }, []);

  const getNetworkName = (chainId) => {
    switch (chainId) {
      case '0x1':
        return 'Ethereum Mainnet';
      case '0xaa36a7':
        return 'Sepolia Testnet';
      default:
        return 'Unknown Network';
    }
  };

  if (!networks || networks.length === 0) {
    return null;
  }

  return (
    <div className="network-selector">
      <select 
        value={currentNetwork || ''} 
        onChange={(e) => switchNetwork(e.target.value)}
        className="network-select"
      >
        {networks.map((network) => (
          <option key={network.chainId} value={network.chainId}>
            {network.chainName}
          </option>
        ))}
      </select>
      <span className="network-icon">🌐</span>
    </div>
  );
}

export default NetworkSelector;
